<template>
  <div class="main">
     <div class="a">
      <div class="a1">
        <button @click="change">Language</button>
      </div>
          <div class="b">
              <img  src="../assets/compay1/logo.png" class="b1">
              <span class="b2">株式会社　サンシャイン</span>
              <span class="b3"><hr/></span>
              <img src="../assets/compay1/cao.png" class="b4">
              <img src="../assets/compay1/hua.png" class="b5">
              <img  src="../assets/compay1/ping.png" class="b6">
              <img  src="../assets/compay1/xiaohua.png" class="b8">
              <span class="b7">Sunshine  LLC</span>
           </div>
          <div class="c">
              <img  src="../assets/compay1/zxzs.png" class="c1">
              <img  src="../assets/compay1/zxyx.png" class="c2">
              <span class="c3">{{ $t("message.company") }}</span>
              <img  src="../assets/compay1/xiaohua.png" class="c4" >
              <span class="c5">{{ $t("message.Overview") }}</span>
              <span class="c6"></span>
              <span class="c7"></span>
           </div>
          <div class="d">
              <span class="d1">株式会社サンシャイン（岐阜県多治見笠原町上原1254-1）<br>
               {{ $t("message.Mainbusinesses") }}<br>
                      {{ $t("message.Contents1") }}<br>
                      {{ $t("message.Contents2") }}<br>
                      {{ $t("message.Contents3") }}<br>
                      {{ $t("message.Contents4") }}<br>
                      {{ $t("message.consult") }}
            </span>
          </div>
       </div>
      <div class="e">
          <div class="f">
              <img src="../assets/compay1/huahua.png" class="f1">
              <h1 class="f2">{{ $t("message.companyOverview") }}</h1>
              <h1 class="f3">ABOUT&nbsp;&nbsp;&nbsp;&nbsp;US</h1>
              <span class="f4"></span>
              <span class="f5"></span>
              <h1 class="f6">{{ $t("message.companyOverview") }}&nbsp;&nbsp;：</h1>  
          </div>
          <div class="g">
                <div class="gg">
                      <img  src="../assets/compay1/xiaohua.png" class="g1">
                      <span class="g2"></span>
                      <h1 class="g3">{{ $t("message.Companyname") }}：</h1>
                      <h1 class="g4">株式会社　サンシャイン</h1>
                      <h1 class="g5">Sunshine  LLC</h1>
                      <span class="g6"></span>
                      <span class="g7"></span>
                      <span class="g8"></span>
                </div>    
                <div class="h">
                      <img  src="../assets/compay1/xiaohua.png" class="hh1">
                      <span class="hh2"></span>
                      <h1 class="hh3">{{ $t("message.Establishmentdate") }}：</h1>
                      <h1 class="hh4">2022年8月16日</h1>
                      <span class="hh5"></span>
                      <span class="hh6"></span>
                      <span class="hh7"></span>
                 </div>
                <div class="j">
                      <img  src="../assets/compay1/xiaohua.png" class="j1">
                      <span class="j2"></span>
                      <h1 class="j3">{{ $t("message.Sukihon") }}：</h1>
                      <h1 class="j4">{{ $t("message.millionyen") }}</h1>
                      <span class="j5"></span>
                      <span class="j6"></span>
                      <span class="j7"></span>
                 </div>
                <div class="k">
                      <img  src="../assets/compay1/xiaohua.png" class="k1">
                      <span class="k2"></span>
                      <h1 class="k3">{{ $t("message.Atable") }}：</h1>
                      <h1 class="k4">{{ $t("message.Representative") }}</h1>
                      <span class="k5"></span>
                      <span class="k6"></span>
                      <span class="k7"></span>
                 </div>
                <div class="l">
                      <img  src="../assets/compay1/xiaohua.png" class="l1">
                      <span class="l2"></span>
                      <h1 class="l3">{{ $t("message.benshe") }}：</h1>
                      <h1 class="l4">岐阜県多治見笠原町上原1254番地の1</h1>
                      <span class="l5"></span>
                      <span class="l6"></span>
                      <span class="l7"></span>
                 </div>
                 <div class="i">
                      <img  src="../assets/compay1/xiaohua.png" class="i1">
                      <span class="i2"></span>
                      <h1 class="i3">{{ $t("message.dier") }}：</h1>
                      <h1 class="i4">岐阜県多治見市下沢町4-45-3</h1>
                      <span class="i5"></span>
                      <span class="i6"></span>
                      <span class="i7"></span>
                 </div>
								 <div class="tel"><!-- 电话 -->
											 <img  src="../assets/compay1/xiaohua.png" class="l1">
											 <span class="l2"></span>
											 <h1 class="l3">T&emsp;E&emsp;L ：</h1>
											 <h1 class="l4">0572-56-5308</h1>
											 <span class="l5"></span>
											 <span class="l6"></span>
											 <span class="l7"></span>
								 </div>
								 <div class="fax"><!-- Fax -->
								 				<img  src="../assets/compay1/xiaohua.png" class="l1">
								 				<span class="l2"></span>
								 				<h1 class="l3">F&emsp;A&emsp;X ：</h1>
								 				<h1 class="l4">0572-56-5309</h1>
								 				<span class="l5"></span>
								 				<span class="l6"></span>
								 				<span class="l7"></span>

								 </div>
								 <div class="email"><!-- Email -->
								 				<img  src="../assets/compay1/xiaohua.png" class="l1">
								 				<span class="l2"></span>
								 				<h1 class="l3">Email &emsp;：</h1>
								 				<h1 class="l4">info@mail.sunshinejp.jp</h1>
								 				<span class="l5"></span>
								 				<span class="l6"></span>
								 				<span class="l7"></span>
								 </div>
									<div class="z">
												<img  src="../assets/compay1/xiaohua.png" class="z1">
												<span class="z2"></span>
												<h1 class="z3">{{ $t("message.Businesscontents") }}：</h1>
												<h1 class="z4">{{ $t("message.Contents1") }}<br>
												{{ $t("message.Contents2") }}<br>
												{{ $t("message.Contents3") }}<br>
												{{ $t("message.Contents4") }}</h1>
												<span class="z5"></span>
												<span class="z6"></span>
												<span class="z7"></span>
									</div>
           </div>
           <div class="el-backtop" style="right: 290px; bottom: 150px;">
                <img  src="../assets/compay1/jiantou.png" class="x1" @click="gotop" v-if="showgo">
           </div>
            <!-- 右侧一排图片 -->
            <div class="sideBox">
            <p class="side">{{ $t("message.productIntroductionp") }}</p>
            <hr class="hr">
            <p class="img1"><img src="../assets/picture/taochi2.jpg"/></p>
            <p class="img2"><img src="../assets/picture/taochi1.jpg"/></p>
            <p class="img3"><img src="../assets/picture/10.jpg"/></p>
            <p class="img4"><img src="../assets/picture/7.jpg"/></p>
            <p class="img5"><img src="../assets/picture/zhonggu2.jpg"/></p>
            <p class="img6"><img src="../assets/picture/zhiwu3.jpg"/></p>
            <p class="img7"><img src="../assets/picture/12.jpg"/></p>
        </div>
        <!-- 引入footer底部 -->
        <div class="footer">
        <homeFooterVue></homeFooterVue>
      </div>
      </div>
   </div>
</template>

<script>
import homeFooterVue from './home-footer.vue';

export default {
  name: 'Company',
  methods: {
    gotop:function() {
        scrollTo(0,0);
    },
    change() {
      console.log("this.$i18n.locale");
      if (this.$i18n.locale == "cn") {
        this.$i18n.locale = "jp"; // 切换日文
      } else {
        this.$i18n.locale = "cn"; // 切换中文
      }
     }
  },
  components:{
    homeFooterVue
  },
  data() {
      return {
        showgo: false
            }
        },
 
  mounted() {
       var vm = this;
        window.onscroll = function() {
          if (document.documentElement.scrollTop > 1000) {
              vm.showgo = true;
                } else {
                    vm.showgo = false;
                }
           }
        }
}
</script>

<style scoped>
  .main{
    height: 2952px; 
    width:100%;
    position: relative;
  }
  /*图片背景*/
  .a{
    position: absolute;
    margin: auto; 
    top: 0;
    right: 0;
    bottom:10;
    left: 0; 
    width:1440px;
    height:852px;
    background-image:url("../assets/compay1/dabeijing.png" );
    background-size: cover;
 }
 /* 语言切换盒子 */
 .a1{
  position: absolute;
  right: 10px;
  top: 5px;
}
/* 语言切换按钮 */
.a1 button{
  border-color: transparent;
  background: #00FF0000;
  /*鼠标变小手*/
  cursor: pointer;
}
  /*左面盒子*/
  .b{
    position:absolute;
    width: 500px;
    height: 150px;
    top:153px;
    left:200px;
  }

  /*图标设置*/
  .b1{
    position:absolute;
    width: 70px;
    height: 70px;
    left:0px;
  }
    /*文字设置*/
  .b2{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    font-size: 25px;
    color: #000000;
    right:130px;
    top:0px;
    }
    /*直线设置*/
  .b3{
    position:absolute;
    width: 275px;
    height: 8px;
    color: darkgray;
    top:28px;
    right:130px;
  }
  /*草*/
  .b4{
    position:absolute;
    width: 22px;
    height: 20px;
    top:45px;
    right:385px;
  }

  /*花*/
  .b5{
    position:absolute;
    width: 19px;
    height: 20px;
    top:45px;
    right:348px;
  }
  /*瓶*/
  .b6{
    position:absolute;
    width: 16px;
    height: 20px;
    top:45px;
    right:313px;
  }
  /*英文*/
  .b7{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    width: 170px;
    height: 24px;
    font-size: 16px;
    color: #000000;
    top:45px;
    right:100px
  }
   /*实心花*/
  .b8{
    position:absolute;
    width: 20px;
    height: 21px;
    top:45px;
    right:260px;
  }
   /*右面盒子*/
  .c{
    position:absolute;
    width: 500px;
    height: 500px;
    top:140px;
    right:190px;
  }
  /*折线左上图片位置设置*/
  .c1{
    position:absolute;
    width: 125px;
    height: 138px;
    right:360px;
  }
  /*折线右下图片位置设置*/
  .c2{
    position:absolute;
    width: 125px;
    height: 138px;
    top:240px;
    right:90px;
  }

 /*会社文字设置*/
  .c3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 100px;
    color: #000000;
    top:20px;
    right:240px;
  }
  /*会社概要实心花设置*/
  .c4{
    position:absolute;
    width: 19px;
    height: 20px;
    bottom:310px;
    right:280px;
  }
  /*概要文字设置*/
  .c5{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 100px;
    color: #000000;
    bottom:150px;
    right:130px;
  }
   /*竖线设置*/
  .c6{
    float: left;
    width: 0.5px;
    height: 330px;
    background: #979797;
    position:absolute;
    top:35px;
    right:30px;
    }
    /*圆设置*/
  .c7{
    position:absolute;
    border-radius:50%;
    width: 18px;
    height: 18px;
    border: 1.1px solid rgba(151,151,151,1);
    top:15px;
    right:22px;
  }
   /*会社概要盒子*/
  .d{
    position:absolute;
    width: 450px;
    height: 200px;
    bottom:90px;
    right:270px;
  }
  /*会社概要文字信息设置*/
  .d1{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #5F5F5F;
    line-height: 31px;
    font-weight: 400;
    display: inline-block;
    text-align: left;
    right:0px;
  }
   /*图片背景*/
  .e{
    position: absolute;
    margin: auto; 
    top: 20;
    right: 0;
    top: 852px;
    left: 0; 
    width:1440px;
    height:2100px;
    background-image:url("../assets/compay1/jianjian.png" );
    background-size: cover;
 }
 /*上面盒子*/
 .f{
    position:absolute;
    width:1040px;
    height:300px;
    right:220px;
 }
 /*花设置*/
 .f1{
    position:absolute;
    width: 170px;
    height: 180px;
    bottom:20px;
    left:30px;
 }
  /*会社概要文字信息设置*/
  .f2{
    writing-mode: vertical-rl;
    position:absolute;
    letter-spacing:9px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 33px;
    color: #3EAE7E;
    line-height: 42px;
    font-weight: 400;
    bottom:22px;
    left:72px;
  }
    /*英文设置*/
  .f3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 25px;
    color: #000000;
    top:110px;
    right:0px;
    font-weight: 400;
  }
   /*横线设置*/
  .f4{
    height: 1px;
    width: 720px;
    background: #979797;
    position:absolute;
    right:5px;
    top:190px;
    }
    /*圆设置*/
  .f5{
    position:absolute;
    border-radius:50%;
    width: 18px;
    height: 18px;
    border: 1px solid rgba(151,151,151,1);
    left:295px;
    top:180px;
  }
  /*会社概要文字设置*/
  .f6{
    position:absolute;
    letter-spacing:2px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 36px;
    color: #000000;
    right:40px;
    top:220px;
  }
   /*下面盒子*/
 .g{
    position:absolute;
    width:600px;
    height:1700px;
    left:220px;
    top:320px;
 }
 /*社名盒子设置*/
 .gg{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:60px;
 }
  /*社名前实心花设置*/
  .g1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
  /*社名前竖线设置*/
  .g2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
  /*社名文字设置*/
  .g3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*文字设置*/
  .g4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }

  /*英文设置*/
  .g5{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:0.5px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:80px;
  }

  /*横线设置*/
  .g6{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .g7{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:134px;
  }
    /*圆设置*/
  .g8{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:134px;
  }
   /*設立日整体位置*/
  .h{
    letter-spacing:10px;
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:220px;
 }
  /*設立日前实心花设置*/
  .hh1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
  /*設立日前竖线设置*/
  .hh2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
  /*設立日文字设置*/
  .hh3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
    /*日期文字设置*/
  .hh4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .hh5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .hh6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .hh7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
  /*資本金整体设置*/ 
  .j{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:380px;
 }
  /*資本金前实心花设置*/
  .j1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
  /*資本金前竖线设置*/
  .j2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
   /*資本金文字设置*/
  .j3{
    letter-spacing:10px;
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*資本金数字设置*/
  .j4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .j5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .j6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .j7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
    /*代表者整体位置*/
  .k{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:540px;
 }
 /*代表者前实心花设置*/
  .k1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
   /*代表者前竖线设置*/
  .k2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
  /*代表者文字设置*/
  .k3{
    letter-spacing:10px;
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
   /*代表取締役包海文字设置*/
  .k4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .k5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .k6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .k7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
   /*本社仓库整体位置*/
  .l{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:700px;
 }
 /*本社仓库前实心花设置*/
  .l1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
  /*本社仓库前竖线设置*/
  .l2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
  /*本社仓库文字设置*/
  .l3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*本社仓库名字文字设置*/
  .l4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .l5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .l6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .l7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
  /*第二仓库整体位置*/
  .i{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:855px;
 }
 /*第二仓库前实心花设置*/
  .i1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
  /*第二仓库前竖线设置*/
  .i2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
  /*第二仓库文字设置*/
  .i3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*第二仓库名字文字设置*/
  .i4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .i5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .i6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .i7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
  /*事業内容整体位置*/
  .z{
    position:absolute;
    width:600px;
    height:280px;
    left:0px;
    top:1440px;
 }
  /*事業内容前实心花设置*/
  .z1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
    /*事業内容前竖线设置*/
  .z2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
   /*事業内容文字设置*/
  .z3{
    letter-spacing:2px;
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*事業内容设置*/
  .z4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    line-height: 37px;
    font-size: 19px;
    color: #726F6F;
    left:130px;
    top:41px;
    display: inline-block;
    text-align: left;
    margin: 0px 0px 0px 120px;
    padding: 0px;
    }
  /*横线设置*/
  .z5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:270px;
    }
    /*圆设置*/
  .z6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:263px;
  }
    /*圆设置*/
  .z7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:263px;
  }
	/*TEL整体位置*/
	 .tel{
	   position:absolute;
	   width:600px;
	   height:150px;
	   left:0px;
	   top:1005px;
	}
	/*fax整体位置*/
	 .fax{
	   position:absolute;
	   width:600px;
	   height:150px;
	   left:0px;
	   top:1148px;
	}

	/*email整体位置*/
	 .email{
	   position:absolute;
     letter-spacing:1px;
	   width:600px;
	   height:150px;
	   left:0px;
	   top:1295px;
	}
/* 底部footer */
  .footer{
  position: absolute;
  top: 1050px;
}

  /* 右侧图片大框 */
  .sideBox {
   position: relative;
   background-color: rgb(238, 248, 250);
   width: 303px;
   height: 1585px;
   left: 945px;
   top: 410px;
}
/* 右侧图片框里面的字 */
.side{
  position: absolute;
  top: 0;
  left: 100px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 22px;
  color: #000000;   
}
/* 右侧图片的虚线 */
.hr{
  position: absolute;
  border:1px dashed rgb(207, 205, 205);
  width: 258px;
  top: 55px;
  left: 20px;
}
/* 右侧图片1 */
.img1 img{
  position: absolute;
  top: 100px;
  left: 26px;
  width: 250px;
  height: 170px;
}
/* 右侧图片2 */
.img2 img{
  position: absolute;
  top: 310px;
  left: 26px;
  width: 250px;
  height: 170px;
}
/* 右侧图片3 */
.img3 img{
  position: absolute;
  top: 519px;
  left: 26px;
  width: 250px;
  height: 170px;
}
/* 右侧图片4 */
.img4 img{
  position: absolute;
  bottom: 470px;
  left: 26px;
  width: 250px;
  height: 170px;
}
/* 右侧图片5 */
.img5 img{
  position: absolute;
  bottom: 256px;
  left: 26px;
  width: 250px;
  height: 170px;
}
/* 右侧图片6 */
.img6 img{
  position: absolute;
  bottom: 40px;
  left: 26px;
  width: 250px;
  height: 170px;
}
/* 右侧图片7 */
.img7 img{
  position: absolute;
  bottom: 680px;
  left: 26px;
  width: 250px;
  height: 170px;
}
   /*回到图标大小顶部*/
  .x1{
    width: 52px;
    height: 47px;
  }
  /*回到顶部*/
.el-backtop {
    position: fixed;
    width: 0px;
    height: 0px; 
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
    z-index: 5;
}


</style>